import React, { forwardRef, type Ref, type ElementType, type MouseEvent } from 'react';
import AddIcon from '@atlaskit/icon/core/add';
import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import Button from '@atlaskit/button';

import { token } from '@atlaskit/tokens';
import Tooltip from '@atlaskit/tooltip';
import type { DropdownTriggerParams } from '@atlassian/jira-development-summary-common/src/common/types.tsx';
import { useIntl } from '@atlassian/jira-intl';
import { fireUIAnalytics } from '@atlassian/jira-product-analytics-bridge';
import messages from './messages.tsx';

export type Props = Partial<
	Flow.Diff<
		DropdownTriggerParams,
		{
			ref: Ref<ElementType>;
		}
	>
>;
export const CreateBranchIconButton = forwardRef<HTMLElement, Props>(
	({ onClick: onClickProp, ...props }, ref) => {
		const { formatMessage } = useIntl();

		const tooltipContent = formatMessage(messages.tooltipContent);
		const onClick = (e: MouseEvent<HTMLElement>, analyticsEvent: UIAnalyticsEvent) => {
			onClickProp && onClickProp();
			fireUIAnalytics(analyticsEvent, 'createBranchIconButton');
		};

		return (
			<Tooltip content={tooltipContent} hideTooltipOnClick>
				<Button
					ref={ref}
					{...props}
					testId="development-summary-branch.ui.create-branch-icon-button.button"
					appearance="subtle"
					iconBefore={<AddIcon label={tooltipContent} color={token('color.icon')} size="small" />}
					onClick={onClick}
				/>
			</Tooltip>
		);
	},
);
